import { defineStyle, defineStyleConfig } from "@chakra-ui/react";
import { colors } from "../tokens/colors";

const baseStyle = defineStyle({
  borderRadius: "0.8rem",
});

const primary = defineStyle(() => {
  return {
    bgColor: colors.primary[500],
    _hover: {
      boxShadow: colors.shadow.primary,
      bgColor: colors.primary[600],
    },
    _disabled: {
      pointerEvents: "none",
    },
    _active: {
      bgColor: colors.primary[700],
    },
  };
});

const secondary = defineStyle(() => {
  return {
    bgColor: "white",
    color: "black",
    _hover: {
      bgColor: "#CECECE",
    },
    _disabled: {
      pointerEvents: "none",
      opacity: 1,
      color: "blackAlpha.500",
      bgColor: "#373737",
    },
    _active: {
      bgColor: "#8B8B8B",
    },
  };
});

const teronary = defineStyle(() => {
  return {
    bgColor: "white",
    color: "black",
    borderRadius: ".4rem",
    border: `2px solid #ACAAA8`,
    boxShadow: "4px 4px 0px 0px #ACAAA8",
    _hover: {
      bgColor: "whiteAlpha.900",
    },
    _active: {
      boxShadow: "none",
    },
    _disabled: {
      boxShadow: "none",
      border: "2px solid transparent",
      opacity: 1,
      bgColor: "whiteAlpha.900",
      pointerEvents: "none",
    },
  };
});

const buttonTheme = defineStyleConfig({
  baseStyle,
  variants: { primary, secondary, teronary },
  defaultProps: { variant: "primary" },
});

export default buttonTheme;
